import axios from "axios"
import Qs from "qs"
import OPTS from './options'

const ax = axios.create({
    baseURL: OPTS.api_url,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
    },
    paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'comma' })
    }
});

const API = {
    async full(parents, id) {
        let res = await ax.get(`/full`, {
            params: {
                parents: parents,
                id: id,
            }
        });

        return res.data;
    },

    async root(id) {
        let res = await ax.get(`/root`, {
            params: {
                id: id,
            }
        });

        return res.data;
    },

    async childrens(id, page) {
        let res = await ax.get(`/childrens`, {
            params: {
                id: id,
                page: page || 1,
            }
        });

        return res.data;
    }
};

export default API;